import Marks from './marks.component';
export default Marks;
